import React from "react";

function Ticket() {
  return <div>Ticket</div>;
}

export default Ticket;
